<template>
  <div class="selftest-mobile">
    <div class="select-camera">
      <h2>Video & audio self test</h2>
      <CameraMicControls
        class="cameracontrol"
        :active="true"
        :user="currentUserId"
        :stream="localCameraStream"
        :canCast="true"
        :testStreamName="streamname"
        :onAir="isCasting"
        :showStopButton="false"
        :wrtcserver="wrtcserver"
        :selfTest="true"
        @setLocalCameraStream="setLocalCameraStream"
        @killLocalCameraStream="killLocalCameraStream"
        @setCurrentCasterStream="startStreaming"
      />
    </div>

    <div class="preview" v-if="state !== 'idle'">
      <div v-if="state === 'reply'">
        <div class="video-wrap-container">
          <div class="test-video-wrap">
            <VideoPlayer
              class="relayvideo"
              QAId="event"
              :streamSrc="videoObject"
            />
            <AudioPlayer
              :key="videoObject.id"
              :volume="20"
              channel="mono"
              :stream="videoObject"
            />
            <VideoPlayer
              class="relayvideo"
              QAId="me"
              style="top: -110px; width: 200px; height: 113px; left: 150px;"
              :streamSrc="selfVideoObject"
            />
            <AudioPlayer
              :key="selfVideoObject.id"
              :volume="100"
              channel="mono"
              :stream="selfVideoObject"
            />
          </div>
        </div>

        <div class="mobile-popover" v-if="nextQuestion !== ''">
          <span class="question">{{ nextQuestion }}</span>
          <el-button
            type="text"
            data-qa="button-yes"
            class="yes"
            @click="answer(true)"
          >
            Yes
          </el-button>
          <el-button
            type="text"
            data-qa="button-no"
            @click="answer(false)"
          >
            No
          </el-button>
        </div>
        <div class="mobile-popover" v-else>
          Hold on for another {{ Math.round((duration - (now - lastStateChange))/1000) }}s, we are checking your network
        </div>
      </div>
      <div v-if="state === 'casting'" class="loadingbox">
        <div class="message">
          <!-- <clip-loader :loading="true" color="#CCC" size="10vw" /> -->
          <icon name="user-clock" color="#666" scale="8" />
          <br>
          Waiting for the echo server to reply...
        </div>
      </div>
      <div v-if="state === 'noreply'" class="loadingbox">
        <div class="message">
          We received no reply from the echo server.
        </div>
        <div class="mobile-popover">
          <button class="el-button" @click="retry">Retry</button>
          <button class="el-button" @click="exit">Close self test</button>
        </div>
      </div>
      <div v-if="state === 'success'" class="loadingbox">
        <div class="message">
          <icon name="mobile-alt" color="rgb(112, 188, 36)" scale="4" />
          <SelfTestSummary :selftestResults="selftestResult" labelQa="label-selftest" /><br>
          This result is saved to your profile.<br>You can always redo the selftest from the account settings.
        </div>
        <div class="mobile-popover">
          <button class="el-button" @click="exit">Close self test</button>
        </div>
      </div>
      <div v-if="state === 'fail'" class="loadingbox">
        <div class="message scrollable">
          <SelfTestSummary :selftestResults="selftestResult" labelQa="label-selftest" /><br>

          <div style="text-align:left;">
            Detected Issue:
            <ul>
              <li v-for="(msg, index) in errormessage" :key="index">{{ msg }}</li>
            </ul>
            Note: This score is a guideline and does not stop you from casting.<br>
            The result is saved to your profile, and you can always redo the selftest from the account settings.
          </div>
        </div>
        <div class="mobile-popover">
          <button class="el-button" @click="retry">Retry</button>
          <button class="el-button" @click="exit">Close self test</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VideoObject from '../../classes/VideoObject'
import { mapState } from 'vuex'
import './SelfTestMobile.scss'
import SelfTestSummary from '@/components/SelfTestSummary'
import CameraMicControls from '@/components/CameraMicControls'
// import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import VideoPlayer from '@/components/VideoPlayer'
import AudioPlayer from '@/components/AudioPlayer'
import { Button } from 'element-ui'
import fb from '../../firebase'

const SELFTEST_DURATION = 30000

// State goes from
// idle -> casting -> reply   -> success
//                            -> fail
//                 -> noreply -> fail

export default {
  name: 'SelfTestMobile',
  props: {
    currentUserId: {
      type: String,
      required: true
    },
    transcodingregion: {
      type: String,
      required: true
    }
  },
  data: () => ({
    videoObject: null,
    selfVideoObject: null,
    isCasting: false,
    streamname: '',
    state: 'idle',
    lastStateChange: 0,
    nowInterval: null,
    now: 0,
    unsubscribeFB: null,
    errormessage: '',
    selftestResult: {
      hearaudio: null,
      seevideo: null,
      hearpreview: null,
      seepreview: null,
      network: { download: {}, upload: {} }
    }
  }),
  mounted () {
    this.goToState('idle')
    this.streamname = 'selftest_' + Math.random().toString(36).replace(/[^a-z]+/g, '')
    this.nowInterval = setInterval(() => {
      this.now = (new Date()).getTime()
      this.checkEverySecond()
    }, 1000)
  },
  destroyed () {
    this.deleteVideoObject()
    this.stopPolling()
    clearInterval(this.nowInterval)
  },
  watch: {
    replyReady (newVal) {
      if (newVal) {
        this.goToState('reply')
        this.startPolling()
      }
    }
  },
  computed: {
    ...mapState({
      localCameraStream: state => state.events.localCameraStream,
      transcodingregions: state => state.admin.transcodingregions
    }),
    userProfile () {
      return this.$store.direct.state.user.profile
    },
    wrtcserver () {
      let server = 'wrtc-va1.kiswe.com'
      if (this.transcodingregions[this.transcodingregion] !== undefined) {
        server = Object.values(this.transcodingregions[this.transcodingregion].wrtcserver)[0].url
      }
      return server
    },
    duration () {
      return SELFTEST_DURATION
    },
    replyReady () {
      return this.selfVideoObject !== null && this.selfVideoObject.bandwidthcounter > 1
    },
    nextQuestion () {
      if (this.selftestResult.seepreview === null) {
        return 'Can you see the preview stream?'
      }
      if (this.selftestResult.hearpreview === null) {
        return 'Can you hear the preview stream?'
      }
      if (this.selftestResult.seevideo === null) {
        return 'Can you see yourself?'
      }
      if (this.selftestResult.hearaudio === null) {
        return 'Can you understand yourself?'
      }
      return ''
    }
  },
  methods: {
    setLocalCameraStream (stream) {
      this.$store.direct.dispatch.events.setLocalCameraStream(stream)
    },
    killLocalCameraStream () {
      this.$store.direct.dispatch.events.killLocalCameraStream()
    },
    deleteVideoObject () {
      if (this.videoObject !== null) {
        this.videoObject.stopPlay()
        this.videoObject = null
      }
      if (this.selfVideoObject !== null) {
        this.selfVideoObject.stopPlay()
        this.selfVideoObject = null
      }
    },
    answer (value) {
      if (this.selftestResult.seepreview === null) {
        this.selftestResult.seepreview = value
      } else if (this.selftestResult.hearpreview === null) {
        this.selftestResult.hearpreview = value
      } else if (this.selftestResult.seevideo === null) {
        this.selftestResult.seevideo = value
      } else if (this.selftestResult.hearaudio === null) {
        this.selftestResult.hearaudio = value
      }
    },
    createVideoObject () {
      this.deleteVideoObject()
      this.videoObject = new VideoObject({
        id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
        streamToPlay: { url: 'rtsp://' + this.wrtcserver + ':1935/livetcp/selftest' },
        logNetwork: true,
        udpEnabled: this.userProfile && this.userProfile.udpEnabled !== undefined ? this.userProfile.udpEnabled : false,
        callback: () => {
          console.log('NEW STREAM')
          // Vue.set(this.streamsManager, id, stream)
        },
        killStream: () => {
          console.log('KILL STREAM')
          this.deleteVideoObject()
          // this.streamsManager[stream.id].stopPlay()
          // this.$delete(this.streamsManager, stream.id)
        },
        restartStream: () => {
          console.log('RESTART STREAM')
          this.createVideoObject()
          // console.log('restartStream', stream)
        }
      })
      this.videoObject.onNetworkStats(this.onNetworkStats)
      this.selfVideoObject = new VideoObject({
        id: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
        streamToPlay: { url: 'rtsp://' + this.wrtcserver + ':1935/livetcp/' + this.streamname },
        logNetwork: true,
        udpEnabled: this.userProfile && this.userProfile.udpEnabled !== undefined ? this.userProfile.udpEnabled : false,
        callback: () => {
          console.log('NEW STREAM')
          // Vue.set(this.streamsManager, id, stream)
        },
        killStream: () => {
          console.log('KILL STREAM')
          this.deleteVideoObject()
          // this.streamsManager[stream.id].stopPlay()
          // this.$delete(this.streamsManager, stream.id)
        },
        restartStream: () => {
          console.log('RESTART STREAM')
          this.createVideoObject()
          // console.log('restartStream', stream)
        }
      })
    },
    goToState (name) {
      this.state = name
      this.lastStateChange = (new Date()).getTime()
    },
    startStreaming () {
      this.isCasting = true
      this.goToState('casting')
      setTimeout(this.createVideoObject, 10000)
    },
    checkEverySecond () {
      if (this.state === 'casting' && this.now - this.lastStateChange > SELFTEST_DURATION) {
        this.goToState('noreply')
        this.errormessage = ['Could not connect with the echo server, check your network and try again']
      }
      if (this.state === 'noreply' && this.now - this.lastStateChange > 10000) {
        this.goToState('fail')
      }
      if (this.state === 'reply' && this.now - this.lastStateChange > SELFTEST_DURATION && this.nextQuestion === '') {
        this.deleteVideoObject()
        if (this.selftestResult.hearaudio &&
            this.selftestResult.seevideo &&
            this.selftestResult.hearpreview &&
            this.selftestResult.seepreview &&
            this.selftestResult.network.upload.score >= 2) {
          this.goToState('success')
        } else {
          this.goToState('fail')
          this.errormessage = []
          if (!this.selftestResult.hearaudio) {
            this.errormessage.push('You were unable to hear yourself well. Please check your computer’s audio settings.')
          }
          if (!this.selftestResult.seevideo) {
            this.errormessage.push('You were unable to see yourself. Please check you camera and try again.')
          }
          if (!this.selftestResult.hearpreview) {
            this.errormessage.push('You were unable to hear the preview well. Check the volume of your headset.')
          }
          if (!this.selftestResult.seepreview) {
            this.errormessage.push('You were unable to see the preview. Please check your network.')
          }
          if (!this.selftestResult.camerapermission) {
            this.errormessage.push('You need to set permissions of your camera')
          }
          if (!this.selftestResult.microphonepermission) {
            this.errormessage.push('You need to set permissions of your microphone')
          }
          if (!this.selftestResult.network.upload.score < 4 && this.errormessage.length === 0) {
            this.errormessage.push('The network selftest scored ' + this.selftestResult.network.upload.score + '/5. ' +
            'Please verify your network, use cable instead of wifi if possible, and reduce other network usage on that same network.')
          }
        }
        this.selftestResult.timestamp = Math.floor((new Date()).getTime() / 1000)
        this.selftestResult.region = this.wrtcserver
        this.$store.direct.dispatch.user.updateProfile({ id: this.currentUserId, selftest: this.selftestResult })
      }
      try {
        navigator.permissions.query({ name: 'camera' }).then(result => {
          this.selftestResult.camerapermission = result.state === 'granted'
        }).catch(error => {
          this.selftestResult.camerapermission = false
          console.error('Could not get camera permissions', error)
        })
        navigator.permissions.query({ name: 'microphone' }).then(result => {
          this.selftestResult.microphonepermission = result.state === 'granted'
        }).catch(error => {
          this.selftestResult.microphonepermission = false
          console.error('Could not get microphone permissions', error)
        })
      } catch (error) {
        console.error('Not able to see permissions of camera or microphone', error)
      }
    },
    stopPolling () {
      if (this.unsubscribeFB !== null) {
        this.unsubscribeFB()
        this.unsubscribeFB = null
      }
    },
    startPolling () {
      this.stopPolling()
      this.unsubscribeFB = fb.db.collection('networkstats').doc(this.currentUserId).onSnapshot(snap => {
        this.selftestResult.network.upload = snap.data().upload
        this.selftestResult.network.download.bandwidth = snap.data().download.bandwidth
      }, error => {
        console.error('error startPolling ' + this.currentUserId + ' ' + error)
      })
    },
    onNetworkStats (stats) {
      console.log('NEW STATS ARRIVED ', stats)
      this.selftestResult.network.download = {
        bandwidth: this.cleanStats(stats.download),
        jitter: this.cleanStats(stats.jitter),
        latency: this.cleanStats(stats.latency),
        score: this.cleanStats(stats.score)
      }
    },
    cleanStats (stat) {
      if (stat === undefined) {
        return 0
      }
      return stat
    },
    retry () {
      const route = this.$router.resolve({ name: 'selftest' })
      window.location.href = route.href
    },
    exit () {
      const route = this.$router.resolve({ name: 'events' })
      window.location.href = route.href
    }
  },
  components: {
    CameraMicControls,
    VideoPlayer,
    AudioPlayer,
    SelfTestSummary,
    'el-button': Button
  }
}

</script>
